import React, { Component } from 'react';
import store, { history } from './store'
import { ConnectedRouter } from 'connected-react-router'
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Provider } from 'react-redux'
import Theme from './Theme'
import WaasApp from './waas/App'
import axios from 'axios'
import { create } from 'jss'
import createGenerateClassName from '@material-ui/styles/createGenerateClassName'
import { jssPreset, StylesProvider } from '@material-ui/styles'
import mixpanel from 'mixpanel-browser';
import jssExtend from "jss-plugin-extend";

const jss = create({ plugins: [jssExtend(), ...jssPreset().plugins] });
const generateClassName = createGenerateClassName({
  productionPrefix: 'cuda',
});


// choose the right api endpoint
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_API_SUPPORT_ENDPOINT + 'v1/support/';

mixpanel.init(process.env.REACT_APP_MIXPANEL);

class App extends Component {
  render() {
    return (
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <StylesProvider jss={jss} generateClassName={generateClassName}>
              <MuiThemeProvider theme={Theme}>
                {<WaasApp />}
              </MuiThemeProvider>
            </StylesProvider>
          </ConnectedRouter>
        </Provider>
    );
  }
}

export default App;
